import {TripbookRepository} from "../../../repositories/TripbookRepository.ts";

export class DownloadEbookUseCase{
    constructor(private tripbooksRepository: TripbookRepository){}
    async execute(invitationCode: string): Promise<void>{
        return this.tripbooksRepository.downloadEbook(invitationCode);
    }
}
